import { queryOptions } from '@tanstack/react-query';
import { BillingAddressService } from './services/BillingAddressService';

export const billingAddressQueryKeys = {
  all: ['billing-addresses'] as const,
  list: () => [...billingAddressQueryKeys.all, 'list'] as const,
};

export const billingAddressQueries = {
  list: () =>
    queryOptions({
      queryKey: billingAddressQueryKeys.list(),
      queryFn: BillingAddressService.getList,
    }),
};
